/* DSL currency display switcher — visual-only, niet checkout */
(function(){
  if (!window.Currency || !window.Currency.rates) return;
  var KEY = "dsl_currency";
  var current = (function(){ try { return localStorage.getItem(KEY); } catch(e){ return null; } })() || (Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
  function fmt(amt, code){
    var r = window.Currency.rates[code] || 1;
    var v = amt * r / (window.Currency.rates.EUR || 1);
    var SYM = {EUR: "€", USD: "$", GBP: "£", CAD: "C$", AUD: "A$"};
    return (SYM[code] || code + " ") + v.toFixed(2).replace(".", code === "EUR" ? "," : ".");
  }
  function applyAll(){
    document.querySelectorAll("[data-money]").forEach(function(el){
      var orig = parseFloat(el.dataset.money);
      if (!isNaN(orig)) el.textContent = fmt(orig, current);
    });
  }
  window.DSL_CURRENCY = {set: function(c){ current = c; try{localStorage.setItem(KEY,c);}catch(e){} applyAll(); if (window.DSL_AB) window.DSL_AB.track("currency_change", {to: c}); }, get: function(){ return current; }, fmt: fmt};
  document.addEventListener("DOMContentLoaded", applyAll);
})();